import { getExperiy } from "src/utils/getDates";
import {
  formatToCurrency,
  roundNumber,
  getComponentKey,
  decimal
} from "src/utils/genericFunctions";

import { PurchaseReportsListData } from "../interface";

export const formatPurchaseRegisterDetails = (purchaseRegisterDetails: any) => {
  return purchaseRegisterDetails?.map(
    (detail: any): PurchaseReportsListData => ({
      docId: detail?.docId,
      vendorName: detail?.vendorName,
      invoice: detail?.invoice,
      po: detail?.po,
      cases: detail?.cases ? decimal(detail?.cases) : 0,
      apCost: detail?.apCost
        ? formatToCurrency(Number(detail?.apCost))
        : detail?.apCost,
      storeCost: detail?.storeCost
        ? formatToCurrency(Number(detail?.storeCost))
        : detail?.storeCost,
      receiptDate: getExperiy(detail.receiptDate),
      entryDate: getExperiy(detail.entryDate),
      invoiceDate: getExperiy(detail.invoiceDate),
      difference:
        detail?.difference == null
          ? "-"
          : formatToCurrency(roundNumber(detail?.difference)),
      receiver: detail.docId,
      key: getComponentKey(),
      type: detail.type,
      wrrEndDate: "",
      hasReversal: detail?.hasReversal
    })
  );
};
